/**
 * 神策事件上报
 * @param {string} event - 事件名称
 * @param {Record<string, unknown>} data - 事件数据
 */

export function track(event: string, data?: Record<string, unknown>) {
  try {
    sensors.track(event, data);
  } catch (error) {
    console.log('sensors track error:', error);
  }
}
